import React, { useEffect, useState } from "react";
import { MdOutlineAnalytics } from "react-icons/md";
import secureLocalStorage from "react-secure-storage";
import { currentUser, DOCTOR_BOOKING_FLAG, getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility";
import CreateTicketScreen from "../../CreateTicket/CreateTicketV2";
import { useCustomer } from "modules/dashboards/actionables/store";
import _ from "lodash";
import CmsAppButton from "modules/navbar/top/CmsAppButton";
import AcademyAppButton from "modules/navbar/top/AcademyAppButton";
import ProfileDropdown from "modules/navbar/top/ProfileDropdown";
import RevampProductsButton from "modules/revamp_products/components/RevampProductsButton";
import { ANALYTICS_EMAIL_WHITELIST } from "config";

const APPS_ROLES = [
  ROLES_NAME.SUPER_ADMIN,
  ROLES_NAME.ADMIN,
  ROLES_NAME.MAKER,
  ROLES_NAME.CHECKER,
  ROLES_NAME.PUBLISHER,
  ROLES_NAME.DOCTOR,
  ROLES_NAME.CLINIC_DOCTOR,
  ROLES_NAME.CONSULT_DOCTOR,
];

const ACADEMY_ROLES = [
  ROLES_NAME.TRAINER,
  ROLES_NAME.MEDICAL_REP,
  ROLES_NAME.OPERATIONS_ADMIN,
  ROLES_NAME.OPERATIONS,
  ROLES_NAME.TEAM_LEAD,
];

const hasAcademyAccess = () => {
  try {
    const userMetaRaw = secureLocalStorage.getItem("user_meta");
    if (userMetaRaw) {
      const meta = typeof userMetaRaw === "string" ? JSON.parse(userMetaRaw) : userMetaRaw;
      if (meta?.is_trainer || meta?.is_academy_admin || meta?.is_onboarding || meta?.is_onboarding_specialist || meta?.training_batch || meta?.academy_role === "trainee") {
        return true;
      }
    }
  } catch (e) {
    // fallback
  }

  const role = getCurrentUserRole();
  if (ACADEMY_ROLES.includes(role)) return true;

  return false;
};

const isAnalyticsWhitelisted = () => {
  const email = secureLocalStorage.getItem("email");
  if (typeof email !== "string") return false;
  return ANALYTICS_EMAIL_WHITELIST.includes(email.toLowerCase());
};

const TopNavRightSideNavItem = () => {
  const { customerData, ticketData } = useCustomer();
  const [isLeadDetailsPage, setIsLeadDetailsPage] = useState(false);

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    setIsLeadDetailsPage(_.get(pathArray, 1) === "lead-details");
  }, [window.location.pathname]);

  const showCms = APPS_ROLES.includes(getCurrentUserRole());
  const showAcademy = hasAcademyAccess();
  const showAnalytics = isAnalyticsWhitelisted();
  const hideCreateTicket =
    ["doctor", "consult_doctor"].includes(currentUser) && !DOCTOR_BOOKING_FLAG;

  return (
    <div className="topbar__right">
      {showAcademy && <AcademyAppButton />}
      {showCms && <CmsAppButton label="CMS" destination="/cms/segments" />}
      {showAnalytics && (
        <CmsAppButton
          label="Analytics"
          destination="/analytics"
          icon={<MdOutlineAnalytics size={18} />}
          color="#13c2c2"
        />
      )}

      <RevampProductsButton />

      {!hideCreateTicket && (
        <CreateTicketScreen
          customerData={isLeadDetailsPage ? customerData : null}
          ticketData={ticketData}
        />
      )}

      <div className="topbar__divider" />

      <ProfileDropdown />
    </div>
  );
};

export default TopNavRightSideNavItem;
